/* eslint-disable no-alert */
/* eslint-disable react/prop-types */

const createSaveConfirmation = (params) => {
  const { callback, language, pathname } = params;

  const multipleLang = {
    zh: '你確定離開此頁面嗎?',
    en: 'Are you sure to leave this page?',
    cn: '你确定离开此页面吗?',
  };

  if (process.env.REACT_APP_LOGIN_VALIDATE === 'true') {
    if (
      ![`/${language}/applications/payment`, `/${language}`].includes(pathname)
    ) {
      const result = window.confirm(multipleLang[language]);
      if (result && callback) {
        callback();
      }
    }
  }
};

export default createSaveConfirmation;
